import { Flex } from '@mantine/core';
import n4nLogoLongHD from '@/assets/images/n4n-logo-long-hd.png';
import n4nLogoLongWhiteHD from '@/assets/images/n4n-logo-long-white-hd.png';
import n4nLogoLong from '@/assets/images/n4n-logo-long.png';

interface AppLogoProps {
  width?: number;
  height?: number;
  variant?: 'default' | 'hd' | 'white';
}

export function AppLogo({ width = 150, height = 31, variant = 'default' }: AppLogoProps) {
  let logo;
  switch (variant) {
    case 'hd':
      logo = n4nLogoLongHD;
      break;
    case 'white':
      logo = n4nLogoLongWhiteHD;
      break;
    default:
      logo = n4nLogoLong;
  }
  return (
    <Flex direction="row" gap={8} align="center">
      <img
        src={logo}
        alt="Night4Night"
        style={{
          width: `${width}px`,
          height: `${height}px`,
          display: 'block',
          flexShrink: 0,
        }}
      />
    </Flex>
  );
}
